(() => {
  "use strict";

  let map;
  let allStores = [];
  const defaultPrefecture = "すべて";
  const fallbackPosition = { lat: 36.2048, lng: 138.2529 };
  const BASE_URL = location.origin;
  const grayscaleStyle = [{ featureType: "all", elementType: "all", stylers: [{ saturation: -100 }] }];

  function getStoreDisplayName(store) {
    const name1 = store?.account_name1 ?? "";
    const name2 = (store?.account_name2 ?? "").trim();
    const suffix = name2 === "・" ? "" : name2;
    return `${name1}${suffix}`;
  }

  // ===== 緯度経度から都道府県を取得 =====
  function getPrefectureFromCoords(lat, lng) {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const components = results[0].address_components;
          const pref = components.find((c) => c.types.includes("administrative_area_level_1"));
          resolve(pref ? pref.long_name : defaultPrefecture);
        } else {
          resolve(defaultPrefecture);
        }
      });
    });
  }

  function getCityFromCoords(lat, lng) {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const components = results[0].address_components;
          const city =
            components.find((c) => c.types.includes("locality")) ||
            components.find((c) => c.types.includes("administrative_area_level_2"));
          resolve(city ? city.long_name : "");
        } else {
          resolve("");
        }
      });
    });
  }

  // ===== 地図初期化関数 =====
  function initGoogleMap(center) {
    const mapEl = document.getElementById("map");
    if (!mapEl) return;
    map = new google.maps.Map(mapEl, {
      center: center,
      zoom: 4,
      styles: grayscaleStyle,
      mapTypeControl: false,
      streetViewControl: false,
    });
  }

  // ===== マーカー描画（住所ベース） =====
  function renderMarkers(stores) {
    if (!map) return;

    const geocoder = new google.maps.Geocoder();

    stores.forEach((store, index) => {
      const address = `${store.prefecture}${store.address1}${store.address2}${store.address3 || ""}`;

      setTimeout(() => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;

            const marker = new google.maps.Marker({
              position: location,
              map,
              title: getStoreDisplayName(store),
              icon: {
                url: "/common/assets/img/icon_pin.svg",
                scaledSize: new google.maps.Size(32, 32),
              },
            });

            marker.addListener("click", () => openStoreModal(store));
          } else {
            console.warn(`住所から位置情報を取得できませんでした (${address})`);
          }
        });
      }, index * 200);
    });
  }

  // ===== モーダル表示処理（住所で地図表示） =====
  function openStoreModal(store) {
    const contentEl = document.getElementById("js-modal-store-content");
    if (!contentEl) return;
    const displayName = getStoreDisplayName(store);
    const address1 = (store.address1 || "").replace(/[\s\u3000]/g, ""); // 半角・全角スペース削除
    const address2 = (store.address2 || "").replace(/[\s\u3000]/g, "");
    const address3 = (store.address3 || "").replace(/[\s\u3000]/g, "");
    const encodedAddress = encodeURIComponent(address1) + encodeURIComponent(address2) + encodeURIComponent(address3);
    const encodedDisplayName = encodeURIComponent(displayName);
    contentEl.innerHTML = `
      <div class="p-shop-modal__heading-wrap">
        <h2 id="js-modal-store-title" class="p-shop-modal__heading">${displayName}</h2>
        <div class="p-shop-modal__heading-icon">
          <a href="https://line.me/R/share?text=${displayName}" target="_blank" aria-label="LINE">
            <svg class="c-icon -icon-line" viewBox="0 0 30 30"><use href="#icon-line"></use></svg>
          </a>
          <a href="mailto:?subject=mi-uniform%EF%BD%9C%E5%BA%97%E8%88%97%E6%83%85%E5%A0%B1&body=${encodedDisplayName}%0D%0A%E3%80%92${encodeURIComponent(store.postal_code)}%0D%0A${encodeURIComponent(store.address1)}${encodeURIComponent(store.address2)}${encodeURIComponent(
      store.address3
    )}%0D%0Ahttps%3A%2F%2Fwww.google.com%2Fmaps%3Fq%3D${encodedAddress}%0D%0ATEL%EF%BC%9A${encodeURIComponent(store.tele_phone)}%0D%0AFAX%EF%BC%9A${encodeURIComponent(store.fax)}" aria-label="メール">
            <svg class="c-icon -icon-email01" viewBox="0 0 30 30"><use href="#icon-email01"></use></svg>
          </a>
        </div>
      </div>
      <div class="p-shop-modal__body">
        <p class="p-shop-modal__text">〒${store.postal_code}</p>
        <p class="p-shop-modal__text">${store.address1}${store.address2}${store.address3 || ""}</p>
        <p class="p-shop-modal__text u-mt-10">TEL：${store.tele_phone || "―"}${store.fax ? `｜FAX：${store.fax}` : ""}</p>
        <div id="js-modal-store-map" class="p-shop-modal__map"></div>
      </div>
    `;

    MicroModal.show("js-modal-store");

    setTimeout(() => {
      const mapEl = document.getElementById("js-modal-store-map");
      if (!mapEl) return;

      const geocoder = new google.maps.Geocoder();
      const address = `${store.prefecture}${store.address1}${store.address2}${store.address3 || ""}`;

      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;

          const modalMap = new google.maps.Map(mapEl, {
            center: location,
            zoom: 16,
            styles: grayscaleStyle,
            mapTypeControl: false,
            streetViewControl: false,
          });

          new google.maps.Marker({
            position: location,
            map: modalMap,
            title: displayName,
            icon: {
              url: "/common/assets/img/icon_pin.svg",
              scaledSize: new google.maps.Size(32, 32),
            },
          });
        } else {
          console.warn("住所から位置情報を取得できませんでした:", address);
          mapEl.innerHTML = `<p style="text-align:center; padding:1em;">地図情報を取得できませんでした。</p>`;
        }
      });
    }, 300);
  }

  // ===== 店舗リスト描画 =====
  function renderStores(stores) {
    const listEl = document.getElementById("js-shop");
    listEl.innerHTML = "";

    if (stores.length === 0) {
      listEl.innerHTML = `<div class="p-shop__map-result-empty">該当する店舗はありません。</div>`;
      return;
    }

    stores.forEach((store) => {
      const displayName = getStoreDisplayName(store);
      const div = document.createElement("div");
      div.className = "p-shop__map-result-item";
      div.innerHTML = `
        <div class="p-shop__map-result-item-name">
          <p class="p-shop__map-result-item-name-text">${displayName}</p>
          <div class="u-flex-shrink u-display-none u-display-block-md"><button class="c-button -black -width-auto" type="button"><svg class="c-icon -icon-map" viewBox="0 0 16 16"><use href="#icon-map"></use></svg><span class="c-button__text">地図を表示</span></button></div>
        </div>
        <div class="p-shop__map-result-item-address">
          <p class="p-shop__map-result-item-address-text">〒${store.postal_code}</p>
          <p class="p-shop__map-result-item-address-text">${store.address1}${store.address2}${store.address3 || ""}</p>
          <p class="p-shop__map-result-item-address-text u-mt-10">TEL：${store.tele_phone || "―"}${store.fax ? `｜FAX：${store.fax}` : ""}</p>
        </div>
        <div class="p-shop__map-result-item-button"><button class="c-button -black -size-sm" type="button"><svg class="c-icon -icon-map" viewBox="0 0 16 16"><use href="#icon-map"></use></svg><span class="c-button__text">地図を表示</span></button></div>
      `;
      div.addEventListener("click", () => openStoreModal(store));
      listEl.appendChild(div);
    });
  }

  // ===== 店舗データ取得 =====
  function fetchStores(prefecture, centerPos) {
    const param = prefecture === "すべて" ? "" : encodeURIComponent(prefecture);
    const url = `${BASE_URL}/shop/search?prefecture=${param}`;
    // console.log("店舗取得URL:", url);

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        allStores = data || [];
        renderStores(allStores);
        renderMarkers(allStores);
        map.setCenter(centerPos);
        updateResultCount(allStores.length);
      })
      .catch((err) => console.error("データ取得エラー:", err));
  }

  // ===== 郵便番号検索（API取得 + 都道府県中心表示） =====
  function filterByKeyword(keywordInput) {
    const titleEl = document.getElementById("js-map-result-title");

    const url = `${BASE_URL}/shop/search?keyword=${encodeURIComponent(keywordInput)}`;
    // console.log("キーワード検索URL:", url);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTPエラー ${res.status}`);
        return res.json();
      })
      .then((data) => {
        const stores = data || [];
        allStores = stores;
        renderStores(stores);
        renderMarkers(stores);
        updateResultCount(stores.length);

        if (stores.length === 0) {
          if (titleEl) titleEl.textContent = "該当なし";
          console.warn("該当する店舗がありません:", keywordInput);
          return;
        }

        // 店舗名検索の場合は入力したキーワードを表示
        if (titleEl) titleEl.textContent = keywordInput;

        // 都道府県の中心を地図に反映
        const prefecture = stores[0].prefecture || defaultPrefecture;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: prefecture }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            map.setCenter(location);
            map.setZoom(10);
            // console.log("都道府県中心へ移動:", prefecture);
          } else {
            console.warn("都道府県中心を取得できませんでした:", prefecture);
            map.setCenter(fallbackPosition);
            map.setZoom(8);
          }
        });
      })
      .catch((err) => {
        console.error("キーワード検索エラー:", err);
        const listEl = document.getElementById("js-shop");
        listEl.innerHTML = '<div class="p-shop__map-result-empty">データを取得できませんでした。</div>';
      });
  }

  // ===== 都道府県でフィルター（API取得） =====
  function filterByPrefecture(prefName) {
    const titleEl = document.getElementById("js-map-result-title");
    const prefSelect = document.getElementById("js-pref-search");
    if (prefSelect) prefSelect.value = prefName;
    if (titleEl) titleEl.textContent = prefName;

    // 「すべて」選択時は空文字パラメータ
    const param = prefName === "すべて" || prefName === "" ? "" : encodeURIComponent(prefName);
    const url = `${BASE_URL}/shop/search?prefecture=${param}`;
    // console.log("都道府県別店舗取得URL:", url);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTPエラー ${res.status}`);
        return res.json();
      })
      .then((data) => {
        allStores = data || [];
        renderStores(allStores);
        renderMarkers(allStores);
        updateResultCount(allStores.length);

        // 都道府県の中心座標を設定
        const geocoder = new google.maps.Geocoder();
        if (prefName === "すべて" || prefName === "") {
          // 「すべて」時は全国表示（東京都中心で広域表示）
          map.setCenter(fallbackPosition);
          map.setZoom(4);
          // console.log("全国（すべて）表示モード");
          return;
        }

        geocoder.geocode({ address: prefName }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            map.setCenter(location);
            map.setZoom(9);
          } else {
            console.warn("都道府県中心を取得できませんでした:", prefName);
            map.setCenter(fallbackPosition);
            map.setZoom(8);
          }
        });
      })
      .catch((err) => {
        console.error("都道府県別データ取得エラー:", err);
        const listEl = document.getElementById("js-shop");
        listEl.innerHTML = '<div class="p-shop__map-result-empty">データを取得できませんでした。</div>';
      });
  }

  // ===== 件数を更新する共通関数 =====
  function updateResultCount(count) {
    const countEl = document.getElementById("js-map-result-count");
    if (countEl) {
      countEl.textContent = `${count}`;
    }
  }

  function scrollToTargetWithOffset(targetSelector) {
    const target = document.querySelector(targetSelector);
    if (!target) return;
    const offsetHeaderH = document.getElementById("js-header").offsetHeight;
    const offset = window.innerWidth < 768 ? offsetHeaderH : 100;
    // if (offset === 100) return;
    new SmoothScroll().animateScroll(target, null, {
      updateURL: false,
      offset: offset,
      speed: 100,
      speedAsDuration: true,
    });
  }

  // ===== 初期化 =====
  window.initMap = function () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        // === 取得成功時 ===
        (pos) => {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;
          const current = { lat, lng };
          initGoogleMap(current);

          Promise.all([getPrefectureFromCoords(lat, lng), getCityFromCoords(lat, lng)]).then(([prefectureName, cityName]) => {
            const prefSelect = document.getElementById("js-pref-search");
            if (prefSelect) {
              [...prefSelect.options].forEach((opt) => {
                opt.selected = opt.value === prefectureName;
              });
            }

            const cityInput = document.getElementById("js-city-search");
            if (cityInput) {
              cityInput.value = cityName;
            }

            const searchPref = prefectureName === "すべて" || !prefectureName ? "" : prefectureName;
            const cityValue = cityName || "";
            const url = `${BASE_URL}/shop/search?prefecture=${encodeURIComponent(searchPref)}&city=${encodeURIComponent(cityValue)}`;

            fetch(url)
              .then((res) => {
                if (!res.ok) throw new Error(`HTTPエラー ${res.status}`);
                return res.json();
              })
              .then((data) => {
                const stores = data || [];
                allStores = stores;
                renderStores(stores);
                renderMarkers(stores);
                updateResultCount(stores.length);

                const titleEl = document.getElementById("js-map-result-title");
                if (titleEl) {
                  if (cityValue) {
                    titleEl.textContent = `${prefectureName} ${cityValue}`;
                  } else {
                    titleEl.textContent = prefectureName || "すべて";
                  }
                }

                if (stores.length === 0) {
                  return;
                }

                const geocoder = new google.maps.Geocoder();
                const address = cityValue ? `${searchPref}${cityValue}` : searchPref;
                geocoder.geocode({ address }, (results, status) => {
                  if (status === "OK" && results[0]) {
                    const location = results[0].geometry.location;
                    map.setCenter(location);
                    map.setZoom(cityValue ? 11 : 9);
                  }
                });
              })
              .catch((err) => {
                console.error("現在地からの店舗取得エラー:", err);
                fetchStores("", current);
              });
          });
        },
        // === 取得失敗時 ===
        () => {
          console.warn("位置情報が取得できませんでした。全国モードにフォールバックします。");
          initGoogleMap(fallbackPosition);
          fetchStores("", fallbackPosition); // 全国取得
          const titleEl = document.getElementById("js-map-result-title");
          if (titleEl) titleEl.textContent = "すべて";
        }
      );
    } else {
      console.warn("Geolocation未対応ブラウザ。全国モードにフォールバックします。");
      initGoogleMap(fallbackPosition);
      fetchStores("", fallbackPosition); // 全国取得
      const titleEl = document.getElementById("js-map-result-title");
      if (titleEl) titleEl.textContent = "すべて";
    }
  };

  // ===== 都道府県でフィルター =====
  function filterByPrefecture(prefName) {
    const titleEl = document.getElementById("js-map-result-title");
    const prefSelect = document.getElementById("js-pref-search");
    if (prefSelect) prefSelect.value = prefName;
    if (titleEl) titleEl.textContent = prefName;

    const param = prefName === "すべて" || prefName === "" ? "" : encodeURIComponent(prefName);
    const url = `${BASE_URL}/shop/search?prefecture=${param}`;
    // console.log("都道府県別店舗取得URL:", url);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTPエラー ${res.status}`);
        return res.json();
      })
      .then((data) => {
        allStores = data || [];
        renderStores(allStores);
        renderMarkers(allStores);
        updateResultCount(allStores.length);

        const geocoder = new google.maps.Geocoder();
        if (prefName === "すべて" || prefName === "") {
          // 全国表示に戻す
          map.setCenter(fallbackPosition);
          map.setZoom(4);
          // console.log("全国（すべて）表示モード");
          return;
        }

        geocoder.geocode({ address: prefName }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            map.setCenter(location);
            map.setZoom(9);
          } else {
            console.warn("都道府県中心を取得できませんでした:", prefName);
            map.setCenter(fallbackPosition);
            map.setZoom(6);
          }
        });
      })
      .catch((err) => {
        console.error("都道府県別データ取得エラー:", err);
        const listEl = document.getElementById("js-shop");
        listEl.innerHTML = '<div class="p-shop__map-result-empty">データを取得できませんでした。</div>';
      });
  }

  // ===== DOM準備完了後 =====
  document.addEventListener("DOMContentLoaded", () => {
    // MicroModal.init(); // script.jsで既に初期化されているため削除

    // ==============================
    // キーワードフォームの検索処理
    // ==============================
    const keywordForm = document.getElementById("js-keyword-search-form");
    if (keywordForm) {
      keywordForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const keyword = document.getElementById("js-keyword-search").value.trim();
        // console.log("キーワード検索:", keyword);

        const prefSelect = document.getElementById("js-pref-search");
        const cityInput = document.getElementById("js-city-search");

        if (keyword) {
          // 入力あり → キーワード検索
          filterByKeyword(keyword);
          if (prefSelect) prefSelect.value = "すべて";
          if (cityInput) cityInput.value = "";
        } else {
          // 入力なし → 全国表示に戻す
          // console.log("キーワード未入力 → 全国表示に切り替え");
          filterByPrefecture("すべて");
          if (prefSelect) prefSelect.value = "すべて";
          if (cityInput) cityInput.value = "";
        }

        scrollToTargetWithOffset("#js-map-result-area");
      });
    }

    // ==============================
    // 都道府県セレクト変更時処理
    // ==============================
    const prefSelect = document.getElementById("js-pref-search");
    if (prefSelect) {
      prefSelect.addEventListener("change", () => {
        const selected = prefSelect.value;

        // 都道府県が変わったら市区町村入力をクリア
        const cityInput = document.getElementById("js-city-search");
        if (cityInput) cityInput.value = "";

        // キーワードもリセット
        const keywordInput = document.getElementById("js-keyword-search");
        if (keywordInput) keywordInput.value = "";

        filterByPrefecture(selected);

        const titleEl = document.getElementById("js-map-result-title");
        if (titleEl) titleEl.textContent = selected;
      });
    }

    // ==============================
    // 市区町村フォームの検索処理
    // ==============================
    const cityForm = document.getElementById("js-city-input-wrapper");
    if (cityForm) {
      cityForm.addEventListener("submit", (e) => {
        e.preventDefault();

        // 選択中の都道府県を取得
        const prefSelect = document.getElementById("js-pref-search");
        const selectedPref = prefSelect ? prefSelect.value.trim() : "";

        // 市区町村名を取得
        const cityInput = document.getElementById("js-city-search");
        const cityValueRaw = cityInput ? cityInput.value.trim() : "";
        const cityValue = cityValueRaw || ""; // 空でも city= を付ける

        // 「すべて」または未選択時はデフォルト都道府県を使用
        const searchPref = selectedPref === "すべて" || !selectedPref ? "" : selectedPref;

        // APIリクエストURL組み立て
        const url = `${BASE_URL}/shop/search?prefecture=${encodeURIComponent(searchPref)}&city=${encodeURIComponent(cityValue)}`;
        // console.log("市区町村検索URL:", url);

        fetch(url)
          .then((res) => {
            if (!res.ok) throw new Error(`HTTPエラー ${res.status}`);
            return res.json();
          })
          .then((data) => {
            const stores = data || [];
            allStores = stores;
            renderStores(stores);
            renderMarkers(stores);
            updateResultCount(stores.length);

            const titleEl = document.getElementById("js-map-result-title");
            if (titleEl) {
              // 都道府県が「すべて」の場合は「すべて」と表示
              const displayPref = selectedPref === "すべて" || !selectedPref ? "すべて" : (searchPref || "すべて");
              titleEl.textContent = cityValue ? `${displayPref} ${cityValue}` : displayPref;
            }

            if (stores.length === 0) {
              console.warn("該当する店舗がありません:", cityValue);
              return;
            }

            // ===== 市区町村中心に地図移動 =====
            const geocoder = new google.maps.Geocoder();
            const address = cityValue ? `${searchPref}${cityValue}` : searchPref;
            geocoder.geocode({ address }, (results, status) => {
              if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;
                map.setCenter(location);
                map.setZoom(cityValue ? 11 : 9);
              } else {
                console.warn("中心位置を取得できませんでした:", address);
              }
            });
          })
          .catch((err) => {
            console.error("市区町村検索エラー:", err);
            const listEl = document.getElementById("js-shop");
            listEl.innerHTML = '<div class="p-shop__map-result-empty">データを取得できませんでした。</div>';
          });

        scrollToTargetWithOffset("#js-map-result-area");
      });
    }
  });
})();
